import { DriverDetails } from "modules/drivers";

const CreateProductPage = () => {
  return <DriverDetails />;
};

export default CreateProductPage;
